
<div class="topbar">
    <button class="menu-mobile"  [class.menu-close]="menuOpened" (click)="toggleMenu()"> 
        <i class="fas fa-bars"></i>
        <i class="fas fa-times"></i>
    </button>
    <app-topbar></app-topbar>
</div>

<app-install-app-button></app-install-app-button>

<div class="body__container">

    <!-- Backdrop para mobile quando menu estiver aberto -->
    <div class="menu-backdrop" [class.show]="menuOpened" (click)="closeMenu()"></div>

    <nav [class.menu-open]="menuOpened">
        <app-navbar></app-navbar>
    </nav>

    <div class="main">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>

</div>
